<template>
   <div class="sign-in-form">
      <p class="text-center">
         Sign into your account
      </p>
      <form @submit.prevent="on_submit">
         <div class="input-group mb-3">
            <div class="input-group-prepend">
               <span class="input-group-text">
                  <i class="fas fa-user"></i>
               </span>
            </div>
            <input type="text" class="form-control" placeholder="Username" aria-label="Username" title="Please enter your username."/>
         </div>

         <div class="input-group mb-3">
            <div class="input-group-prepend">
               <span class="input-group-text">
                  <i class="fas fa-lock"></i>
               </span>
            </div>
            <input type="password" class="form-control" placeholder="Password" aria-label="Password" title="Please enter your password."/>
         </div>

         <button class="btn btn-primary">
            <i class="fas fa-unlock"></i>
            Sign in
         </button>
      </form>
   </div>
</template>

<script>
export default {
   data(){
      return {
         id: Math.floor( Math.random() * 10000000 )
      }
   },
   methods:{
      on_submit(){
         alert( 'Nothing programmed for "submit".' );
      }
   }
}
</script>

<style scoped>
.sign-in-form
{
   border: 0;
}
</style>
